import { Box, Card, CardContent, Tooltip, Typography } from "@mui/material";
import DataSourceIcon from "../../Components/DataSourcesPanel";

const BusinessFocusCard = ({ primaryRegions, focusAreas, consultants }) => {
  return (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Card
        sx={{
          borderRadius: "0.5rem",
          border: "none",
          boxShadow: "0 10px 25px rgba(15, 23, 42, 0.08)",
          overflow: "hidden",
          bgcolor: "#ffffff",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            bgcolor: "#003366",
            color: "#ffffff",
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Tooltip
            title="High-level overview of the client’s footprint, advisory model and investment focus areas."
            arrow
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                fontSize: "1.125rem",
                color: "#ffffff",
                cursor: "help",
              }}
            >
              Business Focus
            </Typography>
          </Tooltip>
          <DataSourceIcon mode="dark" sources={["Salesforce"]} />
        </Box>

        <CardContent sx={{ p: 2.5, flexGrow: 1 }}>
          <Box sx={{ mb: 1.3 }}>
            <Typography sx={{ fontSize: "0.8rem", color: "#6c757d" }}>
              Primary Regions
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", fontWeight: 500 }}>
              {(primaryRegions || []).join(", ")}
            </Typography>
          </Box>

          <Box sx={{ mb: 1.3 }}>
            <Typography sx={{ fontSize: "0.8rem", color: "#6c757d" }}>
              Investment Focus Areas
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", fontWeight: 500 }}>
              {(focusAreas || []).join(", ")}
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontSize: "0.8rem", color: "#6c757d" }}>
              Consultants
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", fontWeight: 500 }}>
              {(consultants || []).length
                ? (consultants || []).join(", ")
                : "None listed"}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default BusinessFocusCard;
